import StringTranslate from '../assets/i18n/stringLanguage.jsx';

const errorCodeHelper = {
    0: undefined,
    1: StringTranslate.msgErrorCodeFertiNPrescriptionIsNull, 
    2: StringTranslate.msgErrorCodeEndWinterNAbsorbedOver, 
    3: StringTranslate.msgErrorCodeCantAdjustPerformanceGoal,
};

export default errorCodeHelper;